import React from 'react';
import {TasksContainer} from 'containers/tasks';
import {offboarding} from 'components/tasks';

const OffboardingTasksContainer = ({...rest}) => {
  return <TasksContainer config={offboarding} {...rest}/>;
};

export default OffboardingTasksContainer;
